/**
 * EF Protection Cards — sync mobile tabs with horizontal card track.
 */
(function () {
  var SECTION_SEL = '[data-ef-protection-cards]';

  function initSection(root) {
    if (!root || root.dataset.efProtectionInit === '1') return;
    root.dataset.efProtectionInit = '1';

    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-protection-tab]')
    );
    var track = root.querySelector('[data-ef-protection-track]');
    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-protection-m-card]')
    );
    var descs = Array.prototype.slice.call(
      root.querySelectorAll('[data-ef-protection-m-desc]')
    );

    if (!tabs.length || !track || !cards.length) return;

    var activeIndex = 0;
    var scrollingFromTab = false;
    var scrollTimer = null;

    function setActive(index, opts) {
      opts = opts || {};
      if (index < 0 || index >= cards.length) return;
      activeIndex = index;

      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      descs.forEach(function (desc, i) {
        if (i === index) {
          desc.removeAttribute('hidden');
        } else {
          desc.setAttribute('hidden', '');
        }
      });

      if (opts.scrollCard) {
        scrollingFromTab = true;
        var card = cards[index];
        if (card) {
          var left = card.offsetLeft - track.offsetLeft;
          track.scrollTo({ left: left, behavior: opts.instant ? 'auto' : 'smooth' });
        }
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          scrollingFromTab = false;
        }, 450);
      }

      if (opts.scrollTab) {
        var tabEl = tabs[index];
        if (tabEl && typeof tabEl.scrollIntoView === 'function') {
          tabEl.scrollIntoView({
            behavior: opts.instant ? 'auto' : 'smooth',
            inline: 'center',
            block: 'nearest',
          });
        }
      }
    }

    function nearestCardIndex() {
      var scrollLeft = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        setActive(i, { scrollCard: true, scrollTab: true });
      });

      tab.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = i + 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = i - 1;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = cards.length - 1;
        if (next < 0 || next >= cards.length) return;
        e.preventDefault();
        setActive(next, { scrollCard: true, scrollTab: true });
        tabs[next].focus();
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        if (scrollingFromTab) return;
        var idx = nearestCardIndex();
        if (idx !== activeIndex) {
          setActive(idx, { scrollTab: true });
        }
      },
      { passive: true }
    );

    setActive(0, { instant: true });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SEL).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector(SECTION_SEL);
    if (root) {
      delete root.dataset.efProtectionInit;
      initSection(root);
    }
  });
})();
